import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-ink px-4 py-16 sm:px-8 md:py-20" data-id="element-54" data-mp="plsky6ka14aa">
      <div className="mx-auto max-w-3xl text-center" data-id="element-55" data-mp="aujyu7fl211w">
        <p className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold-light" data-id="element-56" data-mp="ftwi6i78wpzq">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="1wrjj39v2tei" />
          5 exclusive bonuses — free
        </p>
        <h2 className="mt-5 font-display text-[28px] font-bold leading-tight text-cream sm:text-4xl" data-id="element-58" data-mp="3o1lf0qlfzjix">
          Today you also receive these 5 professional bonuses
        </h2>
        <div className="mt-6 inline-flex flex-col items-center rounded-2xl border border-gold/30 bg-ink-soft px-6 py-4" data-id="element-59" data-mp="3t2slmmbumco0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-cream/60" data-id="element-60" data-mp="1r9bfjn3d9jvd">
            Total bonus value
          </p>
          <p className="font-display text-3xl font-bold text-cream/50 line-through" data-id="element-61" data-mp="3ideks248rw3a">$147</p>
          <p className="mt-1 text-[12px] font-extrabold uppercase tracking-[0.12em] text-gold-light" data-id="element-62" data-mp="3dg4y2u88lyj5">
            Today: included free
          </p>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-4xl space-y-8" data-id="element-63" data-mp="3n5eqkb6ztj7s">
        {bonuses.map(bonus => <article key={bonus.tag} className="overflow-hidden rounded-3xl border border-gold/20 bg-ink-soft" data-id="element-64" data-mp="2zfkh83lvucsa">
            <img src={bonus.image} alt={`${bonus.title} mockup`} className="block w-full bg-white object-contain" width={1254} height={1254} data-id="element-65" data-mp="2uhsmz2xrmekx" />
            <div className="p-5 sm:p-7" data-id="element-66" data-mp="33ja1igviy87i">
              <div className="flex flex-wrap items-center gap-2" data-id="element-67" data-mp="npi3eb9zxus4">
                <span className="rounded-full bg-gold px-3 py-1 text-[11px] font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-68" data-mp="nruk6l40pz3l">
                  {bonus.tag}
                </span>
                <span className="rounded-full border border-gold/40 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-69" data-mp="3cin1723yzcdg">
                  {bonus.value}
                </span>
              </div>
              <h3 className="mt-4 font-display text-[22px] font-bold leading-tight text-cream sm:text-[28px]" data-id="element-70" data-mp="3lhs049jg17q5">
                {bonus.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-cream/75" data-id="element-71" data-mp="2ttq28kxmnvow">{bonus.text}</p>
              {bonus.extra && <p className="mt-3 text-[14px] leading-relaxed text-cream/60" data-id="element-72" data-mp="2xrxnnt31dl6f">{bonus.extra}</p>}
            </div>
          </article>)}
      </div>

      <div className="mx-auto mt-12 max-w-xl" data-id="element-73" data-mp="37kliwjedbh31">
        <CtaButton label="Get all 5 bonuses free" data-id="element-74" data-mp="2a4fqfi105uw2" />
      </div>
    </section>;
}